import { getProductUrl, getIsChdiEligible } from "./lib.js";
const normalizeGRSPharmacyData = (item, translationsConfig) => {
  const { id, product } = item || {};
  const { translations } = translationsConfig || {};
  return {
    isChdiEligible: getIsChdiEligible(item),
    isPublished: true,
    productInfoData: {
      partNumber: id,
      productDescription: translations == null ? void 0 : translations.pharmacytext,
      productImageUrl: translations == null ? void 0 : translations.pharmacyimage,
      productLinkUrl: getProductUrl(product),
      productName: product.title
    }
  };
};
export {
  normalizeGRSPharmacyData
};
